export const OPEN_SLEEP = 'OPEN_SLEEP'